module.exports = __webpack_public_path__ + "77d93c08912bef37685f277d9918a957.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/product-grid.jpg
// module id = 802
// module chunks = 0